export { StyleSecondary } from "./StyleSecondary";
